<template>
    <v-btn-toggle
        v-model="model"
        class="aq-toggle"
        :mandatory="mandatory"
        :disabled="disabled"
        density="compact"
    >
        <AQButton v-for="item in items" :key="String(item.value)" :value="item.value" size="small">
            {{ item.label }}
        </AQButton>
    </v-btn-toggle>
</template>

<script setup lang="ts" generic="T extends string | number | boolean">
    import { computed } from 'vue';
    import AQButton from '@/components/shared/forms/inputs/AQButton.vue';
    import { AQToggleItem } from '@/interfaces/components/AQToggle.types';

    const props = withDefaults(
        defineProps<{
            modelValue: T;
            items: AQToggleItem<T>[];
            mandatory?: boolean;
            disabled?: boolean;
        }>(),
        {
            mandatory: true,
            disabled: false,
        },
    );

    const emit = defineEmits<{
        (e: 'update:modelValue', value: T): void;
    }>();

    const model = computed({
        get: (): T => props.modelValue,
        set: (value: T) => emit('update:modelValue', value),
    });
</script>
